import { CypressAttribute } from '@/test-utils/constants/CypressAttribute';

export const FloatingViewCypressAttribute: CypressAttribute = {
  buttons: {
    TOGGLE_SIZE: 'FloatingViewCypressAttribute:buttons:TOGGLE_SIZE'
  },
  inputs: {},
  views: {}
};
